import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import Landing from "./components/Landing";
import AccountCreation from "./components/AccountCreation/AccountCreation";
import AccountCreation_2 from "./components/AccountCreation_2/AccountCreation_2";
import AuthenticatedRoute from "./AuthenticatedRoute";
import store from "./reducers/store";
import { callApi } from "./lib/utils";
import PatientDashboard from "./components/Dashboard/PatientDashboard";
import PatientProfile from "./components/PatientProfile";
import DiseaseMonitoringSettings from "./components/DiseaseMonitoringSettings";
import PatientContacts from "./components/PatientContacts";
import PatientEventDrillDown from "./components/PatientEventDrillDown";
import Diary from "./components/Diary";
import FAQs from "./components/FAQs";
import AbnormalMotionReports from "./components/Reports/AbnormalMotionReports";
import PaymentMethods from "./components/PaymentMethods";
import PaymentTransactions from "./components/PaymentTransactions";
import ManagePayments from "./components/ManagePayments.js";
import ManageSubscription from "./components/ManageSubscription";
import GeofenceSettings from "./components/GeofenceSettings";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import EventList from "./components/PatientEventDrillDown/LogList";
import ConnectedDevice from "./components/ConnectedDevice";


//import Entities from "./components/Entities";

class RedirectHref extends React.Component {
  constructor(props) {
    super();
    //console.log("props: ", props);
    this.state = { ...props };
  }
  componentWillMount() {
    window.location = "/logout";
  }
  render() {
    //return (<section>Redirecting...{this.state.route.loc}</section>);
    return (
      <div>
        {this.state.loading ? <h1>Loading...</h1> : <span>Redirecting...</span>}
      </div>
    );
  }
}

class AppRouter extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  componentWillMount() {
    const currentPath = window.location.pathname;
    const publicPaths = [
      '/',
      '/create-account',
      '/new/order',
      '/new/order/return',
      '/error',
    ];

    if (!publicPaths.includes(currentPath)) {
      let thisObj = this;
      this.setState({ loading: true }, () => {
        store.dispatch(function (dispatch) {
          callApi("/isAuthenticated", {}, "POST")
            .then((res) => {
              if (res.status === 440) {
                dispatch({ type: "USER_UNSET", data: res.data });
                thisObj.setState({ loading: false });
                window.location = "/login";
              } else {
                dispatch({ type: "USER_SET", data: res.data });
                thisObj.setState({ loading: false });
              }
            })
            .catch((e) => {
              console.log("e: ", e);
            });
        });
      });
    }
  };

  render() {
    return (
      <Router>
        <Switch>
          <Route
            exact
            path="/"
            component={Landing}
            loading={this.state.loading}
          />
          {/* --- Add the new route for account creation --- */}
          <Route
            exact
            path="/create-account"
            component={AccountCreation}
          />
          <Route
            exact
            path="/new/order"
            component={AccountCreation_2}
          />
          <Route
            exact
            path="/new/order/return"
            component={AccountCreation_2}
          />
          <Route
            exact
            path="/logout"
            component={withRouter(RedirectHref)}
            loc="/logout"
          />
          <Route
            exact
            path="/error"
            render={({ location }) => {
              const params = new URLSearchParams(location.search || "");
              const message =
                params.get("message") || "Something went wrong!";
              return <ErrorPage errorMessage={message} />;
            }}
          />
          <AuthenticatedRoute
            exact
            path="/dashboard"
            component={PatientDashboard}
            showHeader={true}
          />
          <AuthenticatedRoute
            exact
            path="/patient/profile"
            component={PatientProfile}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/settings/abnormal-motion"
            component={DiseaseMonitoringSettings}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/settings/hrm"
            component={DiseaseMonitoringSettings}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/settings/fall-detection"
            component={DiseaseMonitoringSettings}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/settings/call-for-help"
            component={DiseaseMonitoringSettings}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/patient/contacts"
            component={PatientContacts}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/drilldown/:eventType"
            component={PatientEventDrillDown}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/event-list/:eventType"
            component={EventList}
            showHeader={false}
          />

          <AuthenticatedRoute
            path="/patient/diary"
            component={Diary}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/faqs"
            component={FAQs}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/report/abnormal-motion"
            component={AbnormalMotionReports}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/payment-methods"
            component={PaymentMethods}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/payment-transactions"
            component={PaymentTransactions}
            showHeader={true}
          />
          <AuthenticatedRoute
            exact
            path="/payments"
            component={ManagePayments}
            showHeader={true}
          />
          <AuthenticatedRoute
            exact
            path="/subscriptions"
            component={ManageSubscription}
            showHeader={true}
          />
          <AuthenticatedRoute
            exact
            path="/settings/geolocation"
            component={GeofenceSettings}
            showHeader={false}
          />
          <AuthenticatedRoute
            exact
            path="/connected-device"
            component={ConnectedDevice}
            showHeader={false}
          />
        </Switch>
      </Router>
    );
  }
}

export default AppRouter;
